module.exports = new __parcel__URL__("falling_sand_incremental_bg.91c7f76c.wasm").toString();